import { instances } from '../default-setup';

// timesheet API
export const getAllHours = (params) => instances.get(`timesheet/`, params);

export const getInferredHours = (params) =>
    instances.get(`hours/report/`, params);

export const updateHours = (userHash, data) =>
    instances.put(`timesheet/${userHash}/`, data);

export const deleteProjectHours = (userHash, projectName, params) =>
    instances.delete(`timesheet/${userHash}/${projectName}/`, params);

// Organistion Projects API
export const getProjects = (params) => instances.get(`hours/projects/`, params);

// Private Projects API
export const getPrivateProjects = (userHash, params,) =>
    instances.get(`hours/projects/${userHash}/`, params);


//Both org &  private projects API
export const createProject = (data) => instances.post(`hours/projects/`, data);
export const updateProject = (data) => instances.put(`hours/projects/`, data);
export const deleteProject = (id) => instances.delete(`hours/projects/${id}/`);

// Get available hours for single project (used when there are two month whithin 1 week)
export const getAvailableHours = (params) =>
    instances.get(`hours/available-hours/`, params);

// Jira Projects
export const getJiraProjects = () => instances.get(`filter/projects/`);

// hours blocks API
export const getCustomers = () => instances.get(`hours/customers/`);
export const createCustomer = (data) => instances.post(`hours/customers/`, data);

export const createHourBlock = (data) =>
    instances.post(`hours/hour-blocks/`, data);
export const updateHourBlock = (data) =>
    instances.put(`hours/hour-blocks/`, data);
export const deleteHourBlock = (id) =>
    instances.delete(`hours/hour-blocks/${id}/`);
